import React from 'react';
import styled from "styled-components"

import BlueQuote from "../../images/icons/quotemarks/quote-no-background/quote_blue.svg"
import GreenQuote from "../../images/icons/quotemarks/quote-no-background/quote_green.svg"
import OrangeQuote from "../../images/icons/quotemarks/quote-no-background/quote_orange.svg"
import YellowQuote from "../../images/icons/quotemarks/quote-no-background/quote_yellow.svg"
import BasicQuote from './svgs/BaiscQuote';

import Text from "./Text"
import theme from "../../styles/theme"

const { font, colors } = theme;

const QuoteBackground = styled.div`
    padding: 40px;
    background-color: ${props => (
        props.sectionColor === 'Submittable Orange' ? colors.primary.lightest : 
        props.sectionColor === 'Teal' ? colors.secondary.lightest : 
        props.sectionColor === 'Yellow' ? colors.tertiary.lightest : 
        props.sectionColor === 'Blue' ? colors.quaternary.lightest : 
        colors.primary.lightest
    )};
    margin: 30px 0 ;

    svg {
        margin-bottom: 24px;
    }

    .quote__author {
        font-family: ${font.bold};
        font-size: 14px;
        line-height: 20px; /* 142.857% */
        letter-spacing: 3px;
        text-transform: uppercase;
        margin-top: 20px
    }
`

const QuoteBody = styled(Text)`
    margin-top: 5px;
    font-family: ${font.recoletaBold};
    color: ${props => (
        props.sectionColor === 'Submittable Orange' ? colors.primary.main : 
        props.sectionColor === 'Teal' ? colors.secondary.main : 
        props.sectionColor === 'Yellow' ? colors.tertiary.dark : 
        props.sectionColor === 'Blue' ? colors.quaternary.main : 
        colors.primary.main
    )};
`
 
const QuoteWithBackground = ({ quoteAuthor, quoteBody, sectionColor, className }) => {
    let subSectionColor;
    switch (sectionColor) {
        case 'Submittable Orange':
            subSectionColor = colors.primary.main;
            break;
        case 'Teal': 
            subSectionColor = colors.secondary.main;
            break;
        case 'Yellow':
            subSectionColor = colors.tertiary.dark;
            break;
        case 'Blue': 
            subSectionColor = colors.quaternary.main;
            break;
        default: 
            subSectionColor = colors.primary.main;
            break;

    }

    return (
        <QuoteBackground sectionColor={sectionColor} className={className}>
            <BasicQuote fill={subSectionColor} />
            <QuoteBody component="body1" sectionColor={sectionColor}>
                {quoteBody}
            </QuoteBody>
            <Text component="caps" className="quote__author">
                {quoteAuthor}
            </Text>
        </QuoteBackground>
    )
}
 
export default QuoteWithBackground;
